import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearRightWheelProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function RearRightWheel(props: RearRightWheelProps) {
  return (
    <svg
      width="178"
      height="66"
      viewBox="0 0 178 66"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 10, right: 213}}
      onClick={props.onClick}
    >
      <path
        d="M153 65H89H25C15 65 1 62 1 48V33V18C1 4 12 1 18 1H89H160C166 1 177 4 177 18L177 33L177 48C177 62 163 65 153 65Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M153 65H89H25C15 65 1 62 1 48V33V18C1 4 12 1 18 1H89H160C166 1 177 4 177 18L177 33L177 48C177 62 163 65 153 65Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M170 61C170 61 135 59 89 59C43 59 8 61 8 61"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1 39C70 41.6667 109 41.6667 177 39"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1 31H177"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M1 23C70 20.3333 109 20.3333 177 23"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M14 1C5.03705 5 6.03293 19 6.03291 23"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M20 1C12.0455 4 13.0398 19 13.0398 23"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M28 1C20.0455 5 21.0398 19 21.0398 23"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M37 1C29.0455 5 30.0398 19 30.0398 23"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M45 1C38.5462 4 39.0072 18 39.0072 22"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M53 1C48 5 48 18 48 22"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M61 1C57 4.90244 57 17.0976 57 21"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M69 1C66 4.90244 66 17.0976 66 21"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M77 1C75 5 75 17.5 75 21.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M85 1C84 4.90244 84 17.0976 84 21"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M164 1C172.963 5 171.967 19 171.967 23"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M157 1C164.955 4 163.96 19 163.96 23"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M149 1C156.955 5 155.96 19 155.96 23"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M141 1C148.955 5 147.96 19 147.96 23"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M133 1C139.454 4 138.993 18 138.993 22"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M125 1C130 5 130 18 130 22"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M117 1C121 4.90244 121 17.0976 121 21"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M109 1C112 4.90244 112 17.0976 112 21"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M101 1C103 5 103 17.5 103 21.5"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M93 1C94 4.90244 94 17.0976 94 21"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M14 61C5.03705 57 6.03293 43 6.03291 39"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M20 61C12.0455 58 13.0398 43 13.0398 39"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M21.0398 39C21.0398 42.715 20.1821 55.0559 26.4325 60"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M30.0398 39C30.0398 42.715 29.1821 55.0559 35.4325 60"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M39.0072 40C39.0072 43.6601 38.6212 55.6929 43.5 60.0098"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M48 40C48 43.7133 48 55.1825 52 60.0077"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M56.9999 41C56.9999 44.3741 56.9999 53.9473 59.5853 59"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M66 41C66 44.3741 66 53.9473 67.939 59"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M75 40.5C75 43.9696 75 53.8344 76.3052 59"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M83.9999 41C83.9999 44.3741 83.9999 53.9473 84.6462 59"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M164 61C172.963 57 171.967 43 171.967 39"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M163.96 39C163.96 42.8238 164.869 56.6998 158 60.5356"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M155.96 39C155.96 42.715 156.818 55.0559 150.568 60"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M147.96 39C147.96 42.708 148.815 55.0097 142.603 59.9722"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M138.993 40C138.993 43.6573 139.378 55.6747 134.511 60"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M130 40C130 43.7113 130 55.1703 126.006 60"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M121 41C121 44.3741 121 53.9473 118.415 59"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M112 41C112 44.3935 112 54.0577 110.027 59.0868"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M103 40.5C103 43.9696 103 53.8344 101.695 59"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
      <path
        d="M94 41C94 44.3741 94 53.9473 93.3536 59"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
      />
    </svg>
  );
}
